import { graphql } from '@apollo/react-hoc';
import get from 'lodash/get';
import uniqWith from 'lodash/uniqWith';
import { compose } from 'react-recompose';
import { isAudienceEqual } from '@purple/match-graphql-schema/lib/schema/common/types/AMAudience/type';
import ConfigureThresholdsPage from './ConfigureThresholdsPage';
import CompetitorsMessagingPage from './CompetitorsMessagingPage';
import MajorsMessagingPage from './MajorsMessagingPage';
import { withEnabledFeatures } from '../../utils/features';
import { SimpleLoadingComponent } from '../../utils/apollo';
import updateAMSubscriptionAcademicThresholds from '../../mutations/HEAccount/updateAMSubscriptionAcademicThresholds';
import updateMajorsMessaging from '../../mutations/HEAccount/updateAMMajorsMessaging';
import updateCompetitorsMessaging from '../../mutations/HEAccount/updateAMCompetitorsMessaging';
import {
  configureThresholdsQuery,
  competitorsMessagingQuery,
  majorsMessagingQuery,
} from './queries';

function dedupe(subscriptions) {
  return uniqWith(subscriptions, (a, b) =>
    isAudienceEqual(get(a, 'node.audience'), get(b, 'node.audience')));
}

const ctData = graphql(configureThresholdsQuery, {
  props: ({ data, ownProps }) => {
    const defaults = get(data, 'viewer.heAccount.activeMatchSubscriptionDefaults', {});
    const subscriptions = get(data, 'viewer.heAccount.activeMatchSubscriptions.edges', []);
    return {
      data,
      defaults,
      subscriptions: dedupe(subscriptions),
    };
  },
});

const updateAcademicThresholdMutation = graphql(updateAMSubscriptionAcademicThresholds, {
  name: 'updateAcademicThreshold',
});

export const AMNextConfigureThresholdsPage = withEnabledFeatures(
  SimpleLoadingComponent(
    ctData,
    updateAcademicThresholdMutation,
  )(ConfigureThresholdsPage),
);

/*
 * CompetitorsMessagingPage graphql configuration
 */
const cmData = graphql(competitorsMessagingQuery, {
  props: (props) => {
    const messages = get(props, 'data.viewer.heAccount.activeMatchMessages', {});
    return {
      ...props,
      messages,
    };
  },
});
const updateCompetitorsMessagingMutation = graphql(updateCompetitorsMessaging, {
  name: 'updateCompetitorsMessaging',
  options: {
    refetchQueries: ['AMCompetitorsMessages'],
  },
});

export const AMNextCompetitorsMessagingPage = compose(
  SimpleLoadingComponent(cmData, updateCompetitorsMessagingMutation),
)(CompetitorsMessagingPage);

/*
 * MajorsMessagingPage graphql configuration
 */
const maData = graphql(majorsMessagingQuery, {
  props: (props) => {
    const messages = get(props, 'data.viewer.heAccount.activeMatchMessages', []);
    return {
      ...props,
      messages,
    };
  },
});

const updateMajorsMessagingMutation = graphql(updateMajorsMessaging, {
  name: 'updateMajorsMessaging',
});

export const AMNextMajorsMessagingPage = compose(
  SimpleLoadingComponent(maData, updateMajorsMessagingMutation),
)(MajorsMessagingPage);
